import { Link } from 'react-router-dom';
import { CreditCard, Map, Zap } from 'lucide-react';

export default function HomePage() {
  return (
    <div className="bg-gradient-to-b from-blue-50 to-white">
      {/* Hero Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-24">
        <div className="text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Gestiona tus eventos con <span className="text-blue-600">asientos numerados</span>
          </h1>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 max-w-3xl mx-auto px-4">
            EventFlow es la plataforma SaaS que te permite crear mapas interactivos de asientos,
            vender entradas y gestionar asistentes de forma profesional.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4">
            <Link
              to="/register"
              className="btn-primary text-base sm:text-lg px-6 sm:px-8 py-3 w-full sm:w-auto"
            >
              Comenzar Gratis
            </Link>
            <Link
              to="/eventos"
              className="btn-secondary text-base sm:text-lg px-6 sm:px-8 py-3 w-full sm:w-auto"
            >
              Ver Eventos
            </Link>
          </div>
        </div>
      </div>

      {/* Features */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8 sm:mb-12">
          Características Principales
        </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            <div className="card text-center">
              <div className="flex justify-center mb-4">
                <Map className="w-10 h-10 text-blue-600" />
              </div>
            <h3 className="text-xl font-bold mb-2">Editor de Mapas Interactivo</h3>
            <p className="text-gray-600">
              Crea mapas de asientos personalizados con nuestro editor visual basado en Konva.js
            </p>
          </div>
            <div className="card text-center">
              <div className="flex justify-center mb-4">
                <Zap className="w-10 h-10 text-blue-600" />
              </div>
            <h3 className="text-xl font-bold mb-2">Actualización en Tiempo Real</h3>
            <p className="text-gray-600">
              Los clientes ven la disponibilidad de asientos actualizada al instante
            </p>
          </div>
            <div className="card text-center">
              <div className="flex justify-center mb-4">
                <CreditCard className="w-10 h-10 text-blue-600" />
              </div>
            <h3 className="text-xl font-bold mb-2">Sistema de Pago Flexible</h3>
            <p className="text-gray-600">
              Acepta pagos por transferencia con verificación de comprobantes
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
